import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CardDetailsModalComponent } from '../card-details-modal/card-details-modal.component';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'card-modal',
	template: require('./card-modal.component.html'),
})
export class CardModalComponent {
	public isRebrading = AppSettings.isRebrading;
	constructor(private activeModal: NgbActiveModal, private modalService: NgbModal) {}

	closeModal(): void {
		this.activeModal.close();
	}

	toggleCardDetails(): void {
		this.activeModal.close();
		const modalRef = this.modalService.open(CardDetailsModalComponent, {
			windowClass: 'modal-small',
		});
		(modalRef.componentInstance as CardDetailsModalComponent).isCardModalflow = true;
	}
}
